export default __webpack_public_path__ + "static/media/arrow-down-new.f768b9ba.svg";